module.exports = __webpack_public_path__ + "static/media/m_beard_stubble_diamond_blonde.1f51baf5.png";